export default "__VITE_ASSET__DhDYC$BP__"